import React from 'react';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';

import { LayoutDynamicZone, LayoutBlockFullHero } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { ProductsListingOverview } from 'src/modules/products';
import { MarketingPageEntity } from 'src/modules/pages';
import { useLocale } from 'src/modules/locale';

interface PagesMarketingProps {
  page?: MarketingPageEntity;
}

const PagesMarketing: React.FunctionComponent<PagesMarketingProps> = (props) => {
  const { getLocalizedObject } = useLocale();

  const { title, description, hero, products, dynamic_content } =
    getLocalizedObject(props).page || {};
  return (
    <LayoutPage title={title} description={description}>
      {hero && <LayoutBlockFullHero {...hero} />}
      {dynamic_content && <LayoutDynamicZone components={dynamic_content} groupCards={true} />}

      {!!products?.length && (
        <section>
          <ProductsListingOverview
            headingTitle="page/lp/section_related_subheading"
            headingMore={false}
            relatedOverview={true}
            products={products}
          />
        </section>
      )}
    </LayoutPage>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return {
    page: state.pages.marketingPage,
  };
};

export default connect(mapStateToProps)(PagesMarketing);
